// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import {
	Group 
} from "@mantine/core";


// Imports from this projects
// Pages, Components, Features, Hooks
import {
	LoginButton 
} from "./LoginButton";

import {
	useAuth
} from "../../hooks/useAuth";


// Interfaces
export interface ProtectedRouteProps {
	children?: any;
}


// Consts
const PleaseLogIn = () => {
	return (
		<Group>
			<LoginButton />
			<p>Please Log in</p>
		</Group>
	);
};


//Exports
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
	const { authState } = useAuth();

	// handle users that are not authenticated
	if (!authState.isAuthenticated) {
		return PleaseLogIn();
	}

	return children;
};